import { IconButton, UIText1, UIText2 } from '@cian/ui-kit';
import { IconFileEdit16, IconFileTrash16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ReplyTemplateItemDesktop.css';

import type { IReplyTemplate } from '../../types/replyTemplates';

type TReplyTemplateItemDesktopProps = {
  template: IReplyTemplate;
  onClick: () => void;
  onEdit: () => void;
  onDelete: () => void;
};

export const ReplyTemplateItemDesktop: React.FC<TReplyTemplateItemDesktopProps> = ({
  template,
  onEdit,
  onClick,
  onDelete,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']} onClick={onClick}>
        {template.name && <UIText2 color="text-secondary-default">{template.name}</UIText2>}
        <UIText1 color="text-primary-default">{template.text}</UIText1>
      </div>

      <div className={styles['actions']}>
        <div className={styles['icon-button']}>
          <IconButton
            icon={<IconFileEdit16 color="icon-main-default" />}
            onClick={onEdit}
            data-name="ReplyTemplateItemEdit"
          />
        </div>
        <div className={styles['icon-button']}>
          <IconButton
            icon={<IconFileTrash16 color="icon-negative-default" />}
            onClick={onDelete}
            data-name="ReplyTemplateItemDelete"
          />
        </div>
      </div>
    </div>
  );
};
